//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "SectionExcursionGallery",
  components: {
    Gallery: () => import('@/components/common/Gallery'),
    Section: () => import('@/components/common/Section/index'),
  },
  computed: {
    ...mapGetters({
      images: 'excursion/images'
    }),
    gallery() {
      return this.images.map((item, index) => ({
        image: item,
        id: index,
        title: '',
        description: ''
      }))
    },
  }
};
